import React from "react";
import ServiceSummaryComponent from "../../components/TripSummary/ServiceSummary/ServiceSummaryComponent";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";
import { useTripSummary } from "../../hooks/useTripSummary";

const TripSummaryContainer = () => {
  const { isLoading, updateTripDetails } = useTripSummary();

  return isLoading ? (
    <GoogleLoader />
  ) : (
    <ServiceSummaryComponent updateTripDetails={updateTripDetails} />
  );
};
export default TripSummaryContainer;
